const vouchers = {
  list: {
    title: "Vouchers List",
    noDataPlaceholder: "No vouchers yet",
    searchPlaceholder: "Search by company name",
    companyName: "Company Name",
    voucherCode: "Voucher Code",
    percentage: "Percentage",
    requestDate: "Request Date",
    creationDate: "Creation Date",
    consumptionDate: "Consumption Date",
    status: "Status",
    generateVoucherButton: "Generate Voucher"
  },
  generateVoucherModal: {
    title: "Generate Voucher",
    labels: {
      companyName: "Company Name",
      voucherCode: "Voucher Code",
      voucherPercentage: "Percentage of Voucher"
    },
    placeholders: {
      companyName: "Enter the Company",
      voucherPercentage: "Enter percentage"
    }
  },
  generateButton: "Generate",
  voucherType: {
    Requests: "Requests",
    notUsed: "Not Used",
    used: "Used"
  },
  generateVoucherSuccessModal: {
    title: "Thank You !",
    content: "The voucher code has been successfully created"
  }
};

export default vouchers;
